import { Card, CardBody } from '@statsbomb/kitbag-components';
import { useStatus } from '@/hooks/useStatus';
import { StatusTranslationKey } from '@/types/status';
import { CardHeightWrapper } from '../card/CardHeightWrapper';
import { ContactSupportStatusDescription } from '../support/ContactSupportCard';
import { ContentStateWrapper } from './ContentStateWrapper';

export const ContentState = ({ status }: { status: StatusTranslationKey }) => {
  const statusProps = useStatus('general', status, {
    [StatusTranslationKey.ERROR]: <ContactSupportStatusDescription />,
  });

  return (
    <ContentStateWrapper id={`${status}-state`}>
      <Card>
        <CardHeightWrapper>
          <CardBody {...statusProps} />
        </CardHeightWrapper>
      </Card>
    </ContentStateWrapper>
  );
};
